// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import plugins from './plugins/core-components'
import axios from './plugins/axios-plugin'
import Vuelidate from 'vuelidate'
import Highcharts from 'highcharts'
import pieInit from 'highcharts/modules/variable-pie'

window.toastr = require('toastr')

pieInit(Highcharts)

Vue.use(BootstrapVue)
Vue.use(axios)
Vue.use(VueToastr2)
Vue.use(plugins)
Vue.use(Vuelidate)

Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js